export const SET_SUBGRUPOS = "SET_SUBGRUPOS";
export const UPDATE_SUBGRUPO_IN_ARRAY = "UPDATE_SUBGRUPO_IN_ARRAY";
export const ADD_SUBGRUPO_IN_ARRAY = "ADD_SUBGRUPO_IN_ARRAY";
export const REMOVE_SUBGRUPO_IN_ARRAY = "REMOVE_SUBGRUPO_IN_ARRAY";
